import { Component, Input, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { RequestTripDetail } from 'src/app/interfaces/RequestTripDetail'
import { ArribalAtPlant, AttributeValues, Client, IDetailTripResponse, Image } from 'src/app/interfaces/Responses/IDetailTripResponse'
import { RealTimeService } from 'src/app/services/dashboards/real-time.service'

@Component({
  selector: 'neoris-detail-truck',
  templateUrl: './detail-truck.component.html',
  styleUrls: ['./detail-truck.component.css']
})
export class DetailTruckComponent implements OnInit {

  _edit: boolean = true
  _dashboardId: string
  _tripID: string
  @Input() responseDetail: IDetailTripResponse
  imagesOfTrucks: Image[]
  arribalAtPlant: ArribalAtPlant[]
  companies: Client[]
  detailTruckForm: UntypedFormGroup
  currentLicensePlate: string
  currentTruckNumber: string
  currentCompany: string
  currentDotNumber: string
  currentType: string
  types: AttributeValues[]

  constructor(
    private realTimeService: RealTimeService,
    private rutaActiva: ActivatedRoute,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.initForm()
    this.setCurrentValues(this.responseDetail)
    if (this.responseDetail.companies != null && this.responseDetail.companies.length > 0) this.companies = this.getCompanies(this.responseDetail.companies)
    if (this.responseDetail.attributeValues != null && this.responseDetail.attributeValues.length > 0) this.types = this.getTypes(this.responseDetail.attributeValues)
    if (this.responseDetail.dotNumber !== null) this.checkedCompany(Number(this.responseDetail.dotNumber))
    if (this.responseDetail.type !== null) this.checkedType(Number(this.responseDetail.type))
    this.arribalAtPlant = this.getArribalAtPlant(this.responseDetail)
    // this._tripID = this.rutaActiva.snapshot.params.tripID
    // this._dashboardId = this.rutaActiva.snapshot.params.dashboardId
    // this.realTimeService.getDetailTrip(this._tripID, this._dashboardId).subscribe(
    //   res => {
    //     if (res !== null) {
    //       this.responseDetail = res
    //       this.setCurrentValues(res)
    //       if (res.companies != null && res.companies.length > 0) this.companies = this.getCompanies(res.companies)
    //       if (res.attributeValues != null && res.attributeValues.length > 0) this.types = this.getTypes(res.attributeValues)
    //       if (this.responseDetail.dotNumber !== null) this.checkedCompany(Number(this.responseDetail.dotNumber))
    //       if (this.responseDetail.type !== null) this.checkedType(Number(this.responseDetail.type))
    //       this.arribalAtPlant = this.getArribalAtPlant(this.responseDetail)
    //     }
    //   }
    // )
  }

  setCurrentValues(res: IDetailTripResponse) {
    this.currentLicensePlate = res.platE_NUMBER
    this.currentTruckNumber = res.truckNumber
    this.currentCompany = res.dotNumber
    this.currentDotNumber = res.dotNumber
    this.currentType = res.type

    // console.log(this.currentLicensePlate)
    // console.log(this.currentTruckNumber)
    // console.log(this.currentCompany)
    // console.log(this.currentDotNumber)
    // console.log(this.currentType)

  }

  initForm() {
    this.detailTruckForm = this.fb.group({
      plateNumber: [''],
      truckNumber: [''],
      govNumber: [''],
      dotNumber: [''],
      attributeValue: [this.responseDetail?.type]
    })
  }

  UpdateDetailTruck(values: any) {
    console.log(values)
    let requesTripDetail = new RequestTripDetail
    requesTripDetail.tripId = Number(this._tripID)
    requesTripDetail.license = this.currentLicensePlate
    requesTripDetail.dotNumber = this.currentDotNumber
    requesTripDetail.truckNumber = this.currentTruckNumber
    requesTripDetail.truckType = Number(this.currentType)
    // requesTripDetail.license = values.plateNumber
    // requesTripDetail.dotNumber = values.dotNumber
    // requesTripDetail.truckNumber = values.truckNumber
    // requesTripDetail.truckType = values.attributeValue
    this.realTimeService.UpdateTripDetail(requesTripDetail).subscribe((e) => {
      document.getElementById('resolution').style.display = 'block'
      setTimeout(() => {
        document.getElementById('resolution').style.display = 'none'
      }, 3000)
      console.log(e)
    })
    this.toogleEdit()
  }

  checkedCompany(govNumber: number) {
    let exist = this.companies.filter(c => c.govNumber === govNumber)
    if (exist.length > 0) this.companies.filter(c => c.govNumber === govNumber)[0].selected = true
  }

  checkedType(id: number) {
    let exist = this.types.filter(c => c.id === id)
    if (exist.length > 0) this.types.filter(c => c.id === id)[0].selected = true
  }

  getCompanies(companies: Client[]): Client[] {
    let companiesList: Client[] = []
    let companiesObj: Client
    companies.forEach(element => {
      companiesObj = new Client()
      companiesObj.name = element.name
      companiesObj.govNumber = element.govNumber || 0
      companiesObj.selected = false
      companiesList.push(companiesObj)
    })
    return companiesList
  }

  getTypes(attributeValues: AttributeValues[]): AttributeValues[] {
    let typeList: AttributeValues[] = []
    let typeObj: AttributeValues
    attributeValues.forEach(element => {
      typeObj = new AttributeValues()
      typeObj.id = element.id
      typeObj.nameEn = element.nameEn
      typeObj.nameEs = element.nameEs
      typeObj.selected = false
      typeList.push(typeObj)
    })
    return typeList
  }

  getArribalAtPlant(responseDetail: IDetailTripResponse): ArribalAtPlant[] {
    let arribalAtPlant: ArribalAtPlant[] = []
    let arribalAtPlantObj: ArribalAtPlant
    responseDetail?.checkpoinT_STEPS?.forEach(element => {
      arribalAtPlantObj = new ArribalAtPlant()
      arribalAtPlantObj.steP_NAME = element.steP_NAME
      arribalAtPlantObj.averagE_TIME = element.averagE_TIME
      arribalAtPlantObj.averagE_MINUTES = element.averagE_MINUTES
      arribalAtPlantObj.averagE_MINUTES_HHMM = element.averagE_MINUTES_HHMM
      // arribalAtPlantObj.image_truck = responseDetail.images.filter(e => e.attributeType === 2 && element.steP_ID === e.checkpoinT_ID).length > 0 ? responseDetail.images.filter(e => e.attributeType === 2 && element.steP_ID === e.checkpoinT_ID)[0].imagE_URL : ''
      // arribalAtPlantObj.image_license = responseDetail.images.filter(e => e.attributeType === 11 && element.steP_ID === e.checkpoinT_ID).length > 0 ? responseDetail.images.filter(e => e.attributeType === 11 && element.steP_ID === e.checkpoinT_ID)[0].imagE_URL : ''
      // arribalAtPlantObj.image_truck_number = responseDetail.images.filter(e => e.attributeType === 13 && element.steP_ID === e.checkpoinT_ID).length > 0 ? responseDetail.images.filter(e => e.attributeType === 13 && element.steP_ID === e.checkpoinT_ID)[0].imagE_URL : ''
      // arribalAtPlantObj.image_dot = responseDetail.images.filter(e => e.attributeType === 12 && element.steP_ID === e.checkpoinT_ID).length > 0 ? responseDetail.images.filter(e => e.attributeType === 12 && element.steP_ID === e.checkpoinT_ID)[0].imagE_URL : ''
      // arribalAtPlantObj.image_company = responseDetail.images.filter(e => e.attributeType === 14 && element.steP_ID === e.checkpoinT_ID).length > 0 ? responseDetail.images.filter(e => e.attributeType === 14 && element.steP_ID === e.checkpoinT_ID)[0].imagE_URL : ''
      arribalAtPlant.push(arribalAtPlantObj)
    })
    return arribalAtPlant
  }

  toogleEdit() {
    this._edit = !this._edit
  }

  edit() {
    this.toogleEdit()
  }

  zoom(urlImage: string) {
    document.getElementById("img01").setAttribute('src', urlImage)
    document.getElementById('myModal').style.display = 'block'
  }

  closeModal() {
    document.getElementById('myModal').style.display = 'none'
  }

  changeCompany(company: string) {
    this.responseDetail.dotNumber = company
    this.currentDotNumber = company
    document.getElementById('dotNumber').setAttribute('placeholder', company)
    document.getElementById('dotNumber').setAttribute('value', company)
  }

  changeType(type: string) {
    // this.currentType = type
    // console.log(type)
  }

  onKeyLP(value: any) {
    // this.currentLicensePlate = value;
    // console.log(this.currentLicensePlate)
    // console.log(value)
  }

  onKeyTN(value: string) {
    // this.currentTruckNumber = value;
    // console.log(this.currentTruckNumber)
  }

  onKeyDN(value: string) {
    // this.currentDotNumber = value;
    // console.log(this.currentDotNumber)
  }

}
